"use client";

import { formatPlainDate, parsePlainDate, type PlainDate } from "@kedaat/engine";

const button =
  "inline-flex min-h-10 items-center justify-center rounded-xl border border-line bg-card px-3 text-sm font-medium transition-colors hover:bg-accent-soft disabled:opacity-40";

export function DateNav({
  date,
  isToday,
  onChange,
  onPrevious,
  onNext,
  onToday,
  className = "",
}: {
  date: PlainDate;
  isToday: boolean;
  onChange: (date: PlainDate) => void;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
  className?: string;
}) {
  return (
    <nav aria-label="בחירת תאריך" className={`items-center gap-2 ${className}`}>
      <button type="button" onClick={onPrevious} className={button} aria-label="היום הקודם">
        →<span className="hidden sm:inline">&nbsp;הקודם</span>
      </button>
      <input
        type="date"
        aria-label="תאריך"
        value={formatPlainDate(date)}
        onChange={(e) => {
          if (e.target.value) onChange(parsePlainDate(e.target.value));
        }}
        className={`${button} min-w-0 flex-1 text-center sm:flex-none`}
      />
      <button type="button" onClick={onNext} className={button} aria-label="היום הבא">
        <span className="hidden sm:inline">הבא&nbsp;</span>←
      </button>
      <button type="button" onClick={onToday} disabled={isToday} className={button}>
        היום
      </button>
    </nav>
  );
}
